import React from 'react'
import { StoreZoneTable } from '../components';

/**
 * Tawreed Users Page
 * @returns 
 */
export const StoreZonesPage: React.FC = () => (<StoreZoneTable />);

